module.exports = "https://web-assets-production.autolist.com/_next/static/images/hartford-ct-a2c58b7e9afdfab4fecd466093f6ae85.jpg";